import SEO from "@/components/SEO";

export default function Policy() {
  return (
    <>
      <SEO
        title="Privacy Policy & Terms of Service"
        description="Privacy policy and terms of service for Orina Enterprise."
        path="/policy"
      />

      <section className="border-b-2 border-black bg-white py-16 md:py-20">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <div className="tape">Legal</div>
          <h1 className="display mt-6 text-4xl font-black tracking-tight md:text-5xl">Policies</h1>
          <p className="mt-3 text-base text-black/70">Last updated: December 2025</p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mx-auto max-w-3xl space-y-12 px-4 md:px-8">
          <div>
            <h2 className="display text-2xl font-black md:text-3xl">Privacy Policy</h2>
            <div className="mt-5 space-y-4 text-base leading-relaxed text-black/85">
              <p>
                Orina Enterprise ("we", "us", "our") respects your privacy. This Privacy Policy explains how we collect, use and protect information when you use our website and services.
              </p>
              <p>
                <strong>Information we collect.</strong> Contact details you submit through forms (name, email, phone, company), and basic analytics about your interaction with our website. We do not sell your personal data.
              </p>
              <p>
                <strong>How we use it.</strong> To respond to your enquiry, send relevant updates about our services, and improve our website. We may share data with trusted operational vendors (analytics, email) under confidentiality obligations.
              </p>
              <p>
                <strong>Data retention.</strong> We retain submitted information for as long as needed to serve you, comply with legal obligations, and resolve disputes. You can request deletion at any time by emailing letstalk@orinaenterprise.com.
              </p>
              <p>
                <strong>Cookies.</strong> Our site uses essential and analytics cookies. You can control cookies through your browser settings.
              </p>
            </div>
          </div>

          <div>
            <h2 className="display text-2xl font-black md:text-3xl">Terms of Service</h2>
            <div className="mt-5 space-y-4 text-base leading-relaxed text-black/85">
              <p>
                These Terms govern your use of the Orina Enterprise website and the services we provide.
              </p>
              <p>
                <strong>Services.</strong> We provide e-commerce account management, marketplace onboarding, listing optimization, ads management, and website / app development services. The exact scope of any engagement is set out in a written proposal or agreement.
              </p>
              <p>
                <strong>Fees.</strong> Fees are payable as agreed in your engagement document. Onboarding fees are typically charged upfront; account management is billed monthly. Taxes are additional where applicable.
              </p>
              <p>
                <strong>Confidentiality.</strong> Both parties agree to keep confidential information shared in the course of an engagement secure and limited to authorised personnel.
              </p>
              <p>
                <strong>Limitation of liability.</strong> Orina is not liable for marketplace decisions, suspensions, or third-party policy changes outside our control. Our maximum aggregate liability is limited to fees paid in the prior 3 months.
              </p>
              <p>
                <strong>Governing law.</strong> These Terms are governed by the laws of India. Disputes are subject to the exclusive jurisdiction of courts in Mumbai, Maharashtra.
              </p>
              <p>
                <strong>Contact.</strong> Questions? Email letstalk@orinaenterprise.com.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
